import QRCode from 'qrcode';
import { isPaymentQrPrinted } from '@shared/customer-display/paymentQr';

export default {
  methods: {
    // Keep print visibility in the shared setting map.
    paymentQrPrinted(docTypeId, setting) {
      return isPaymentQrPrinted(docTypeId, setting);
    },
    renderPromptPayQrs() {
      const documents = Array.isArray(this.form) ? this.form : [];
      return Promise.all(
        documents.map((document) => {
          if (!document || !document.promptpay_qr_payload || document.qr_code_payment) {
            return Promise.resolve();
          }
          return new Promise((resolve) => {
            QRCode.toDataURL(
              document.promptpay_qr_payload,
              { errorCorrectionLevel: 'M', margin: 1, width: 240 },
              (error, dataUrl) => {
                if (!error) this.$set(document, 'qr_code_payment', dataUrl);
                resolve();
              }
            );
          });
        })
      );
    },
    waitForPaymentQrImages() {
      const images = this.$el
        ? Array.from(this.$el.querySelectorAll('[data-payment-qr]'))
        : [];

      return Promise.all(
        images.map((image) => {
          if (image.complete) return Promise.resolve();

          return new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        })
      );
    },
    qrPaymentDestination(document) {
      const snapshot = document && document.qr_payment_snapshot;
      // An uploaded shop QR has no payee name inside it; show the text the owner typed.
      if (snapshot && snapshot.mode === 'template') return String(snapshot.account_name || '').trim();
      if (!snapshot || snapshot.mode !== 'promptpay') return '';
      const name = snapshot.account_name || snapshot.bank_name || 'PromptPay';
      return `พร้อมเพย์: ${name}`;
    },
  },
};
